import { useEffect, useRef, useState } from 'react';

export type CepStatus = 'idle' | 'loading' | 'ok' | 'notfound';

export const onlyDigits = (v: string) => v.replace(/\D/g, '');
export const formatCep = (v: string) => {
  const d = onlyDigits(v).slice(0, 8);
  return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
};

/**
 * Busca cidade/UF do CEP no ViaCEP quando ele fica com 8 dígitos e entrega o
 * resultado em `onFound`. Só o CEP dispara a busca.
 */
export function useViaCep(cep: string, onFound: (local: { cidade: string; uf: string }) => void) {
  const [status, setStatus] = useState<CepStatus>('idle');
  const onFoundRef = useRef(onFound);
  onFoundRef.current = onFound;
  const digits = onlyDigits(cep);

  useEffect(() => {
    if (digits.length !== 8) {
      setStatus('idle');
      return;
    }
    const ctrl = new AbortController();
    setStatus('loading');
    fetch(`https://viacep.com.br/ws/${digits}/json/`, { signal: ctrl.signal })
      .then((r) => r.json())
      .then((d: { erro?: boolean; localidade?: string; uf?: string }) => {
        if (d.erro || !d.localidade) {
          setStatus('notfound');
          return;
        }
        setStatus('ok');
        onFoundRef.current({ cidade: d.localidade, uf: d.uf ?? '' });
      })
      .catch((e: unknown) => {
        if ((e as { name?: string })?.name !== 'AbortError') setStatus('notfound');
      });
    return () => ctrl.abort();
  }, [digits]);

  return status;
}
